import * as React from "react";
import { mk_widget } from "widgets-for-react";

type StyleguideChapterProps = {
  slug?: string
  title: string
  intro?: string
  extraClasses?: string
}

export const StyleguideChapter = (props: StyleguideChapterProps) => w => mk_widget({
  run: _ => (
    <>
      <section className={`styleguide-chapter ${props.extraClasses ? props.extraClasses : ''}`}>
        <span id={props.slug} className="styleguide__anchor" aria-hidden="true"></span>

        <header className="styleguide--styled styleguide-chapter__header">
          {props.title && <h2 className="styleguide__title styleguide-chapter__title">{props.title}</h2>}
          {props.intro && <p className="styleguide-chapter__intro">{props.intro}</p>}
        </header>

        <div className="styleguide-chapter__content">
          {w.run(_ => null)}
        </div>
      </section>
    </>
  )
})

type StyleguideSectionProps = {
  slug: string
  title: string
  intro?: string
  extraClasses?: string
}

export const StyleguideSection = (props: StyleguideSectionProps) => w => mk_widget({
  run: _ => (
    <section className={`styleguide-section ${props.extraClasses ? props.extraClasses : ''}`}>
      <span id={props.slug} className="styleguide__anchor" aria-hidden="true"></span>

      <header className="styleguide--styled styleguide-section__header">
        {props.title && <h3 className="styleguide-section__title">{props.title}</h3>}
        {props.intro && <p className="styleguide-section__intro">{props.intro}</p>}
      </header>

      <div className="styleguide-section__content">
        {w.run(_ => null)}
      </div>
    </section>
  )
})

type StyleguidePartProps = {
  title: string;
  intro?: string;
  isFullScreen?: boolean;
};

export const StyleguidePart = (props: StyleguidePartProps) => w => mk_widget({
  run: _ => (
    <section className="styleguide-part">
      <header className="styleguide--styled styleguide-part__header">
        <h4 className="styleguide-part__title">{props.title}</h4>
      </header>

      <div className="styleguide-part__content">
        <div className="styleguide--styled styleguide-part__intro">
          {props.intro && <p className="styleguide-part__description">{props.intro}</p>}
        </div>

        <section className="styleguide-example">
          <div className="styleguide--styled">
            <h5 className="styleguide-example__title">Example(s)</h5>
          </div>

          <div className="styleguide-example__section cf">
            {props.isFullScreen == true ? (
              <div className="fs">
                <div className="fs__inner">
                  {w.run(_ => null)}
                </div>
              </div>
            ) : (
              w.run(_ => null)
            )}
          </div>
        </section>
      </div>
    </section>
  )
});

type StyleguidePlaceholderShapeProps = {
  width: number
  height: number
  radius: string
  bgColor: string
}

type StyleguidePlaceholderTextProps = {
  color: string
  font?: string
}

type StyleguidePlaceholderProps = {
  shape: StyleguidePlaceholderShapeProps,
  text?: StyleguidePlaceholderTextProps
}

// HOW TO USE: <img src={styleguidePlaceholder({ shape: { width: 200, height: 75, radius: '0', bgColor: '#E8E8E8' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })} ... />
export function StyleguideImgPlaceholder(p: StyleguidePlaceholderProps): string {
  return `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="${p.shape.width}" height="${p.shape.height}" viewBox="0 0 ${p.shape.width} ${p.shape.height}"><rect rx="${p.shape.radius}" width="${p.shape.width}" height="${p.shape.height}" x="0" y="0" fill="${encodeURIComponent(p.shape.bgColor)}"/>${p.text && (`<text style="color: ${encodeURIComponent(p.text.color)}; font-size: ${(p.shape.width * .075)}px;${p.text.font && (` font-family: ${p.text.font};`)}" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">${p.shape.width}x${p.shape.height}</text>`)}</svg>`
}



// WEBPACK FOOTER //
// ./Client/styleguide/components/helpers.tsx